import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {

  public transform(value: any[], filter: object, invert: boolean = false): any[]{

    return value.filter(item => {
      for (let i in filter) {
        if(filter[i] instanceof Array){
          if(filter[i].indexOf(item[i]) === -1) {
            return invert;
          }
        }
        else if (!item[i] || item[i] != filter[i]) {
          return invert;
        }
      }
      return !invert;
    });
  }

}
